import { gql } from "@outschool/ui-apollo";
import { AttachmentFragment } from "@outschool/ui-components-classroom";

export const ActivityFragment = gql`
  fragment ActivityFragment on Activity {
    uid
    slug_id
    user_uid
    title
    titleTranslated
    url
    path
    class_experience
    learning_goals
    learningGoals
    assessment
    homework
    grading_policy
    prerequisites
    published_at
    is_online
    strictAgeRange {
      min
      max
    }
    age_min
    age_max
    proficiency_level {
      level
      text
    }
    english_proficiency_level
    grade_level_min
    grade_level_max
    size_min
    size_max
    duration_minutes
    duration_weeks
    weekly_meetings
    price_cents
    priceCredits
    summary
    summaryTranslated
    is_ongoing_weekly
    subject
    refundPolicy {
      name
      description
      type
    }
    details {
      photo
      photoSquare
    }
    photo {
      ...AttachmentFragment
    }
    photoSquare {
      ...AttachmentFragment
    }
    languageOfInstruction
    summaryForLearners
    allowWaitlist
    isClub
    isAutoSchedulingEnabled
    autoSchedulingDaysNoticeMin
    autoSchedulingDaysNoticeMax
    allows_recurring_payment
    allows_late_enrollments_for_fixed_length_classes
    allowsFutureOngoingEnrollments
    has_building_content
    hasTeacherSchedule
    isFlexSchedule
    isSelfPaced
    isOneTime
    classFormat
    classroomType
    isIncludedWithMembership
  }
  ${AttachmentFragment}
`;
